"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Circle = exports.Grid = exports.Metadata = void 0;
exports.toArray = toArray;
const Area_1 = require("../../../Area");
const Point_1 = require("./Point");
function toArray(obj) {
    if (obj === null || obj === undefined) {
        return [];
    }
    return Array.isArray(obj) ? obj : [obj];
}
class Metadata {
    constructor() {
        this.parserVersion = '0.0.1';
        this.boundary = new Area_1.default();
    }
    static createFromSchematic(sch) {
        const metadata = new Metadata();
        metadata.cadTool = 'eagle';
        metadata.cadToolVersion = sch._attributes.version;
        return metadata;
    }
    static createFromBoard(brd) {
        const metadata = new Metadata();
        metadata.cadTool = 'eagle';
        metadata.cadToolVersion = brd._attributes.version;
        return metadata;
    }
}
exports.Metadata = Metadata;
class Grid {
    constructor(g) {
        this.distance = parseInt(g._attributes.distance);
        this.altDistance = parseInt(g._attributes.altdistance);
    }
}
exports.Grid = Grid;
class Circle {
    static createFromEagleSchematic(c, parent) {
        const circle = new Circle();
        circle.point = new Point_1.Point(c._attributes.x, c._attributes.y);
        circle.radius = parseFloat(c._attributes.radius);
        circle.width = parseFloat(c._attributes.width);
        circle.layer = parseInt(c._attributes.layer);
        circle.point = circle.point.rotate(parent.rotation);
        if (parent.mirrored) {
            circle.point.x = -circle.point.x;
        }
        circle.point.add(parent.point);
        return circle;
    }
    getArea() {
        const area = new Area_1.default();
        area.extend([this.point.x - this.radius, this.point.y - this.radius]);
        area.extend([this.point.x + this.radius, this.point.y + this.radius]);
        return area;
    }
}
exports.Circle = Circle;
//# sourceMappingURL=Common.js.map